import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CourierDeliveryInfo } from 'schema'

import { ORDER_ADD_INITIAL_STATE } from './constants'
import { OrderAddStore, PointInfo } from './types'

export type PointInfoSet<T> = {
  key: CourierDeliveryInfo.pointType
  value: T
}
function getPointType(key: CourierDeliveryInfo.pointType) {
  if (key === CourierDeliveryInfo.pointType.DEPARTURE) {
    return 'fromPoint'
  }

  return 'toPoint'
}
export const orderAddSlice = createSlice({
  name: 'customerAdd',
  initialState: ORDER_ADD_INITIAL_STATE,
  reducers: {
    clearOrderAddStore: () => ORDER_ADD_INITIAL_STATE,
    setOrderAddPointSelectedOption: (
      state,
      { payload: { key, value } }: PayloadAction<PointInfoSet<PointInfo['selectedOption']>>
    ) => {
      state[getPointType(key)].selectedOption = value
    },
    setOrderAddPointDaDataSearchAddressValue: (
      state,
      { payload: { key, value } }: PayloadAction<PointInfoSet<PointInfo['daDataSearchAddressValue']>>
    ) => {
      state[getPointType(key)].daDataSearchAddressValue = value
    },
    setOrderAddIsAddressCourierDelivery: (
      state,
      { payload: { key, value } }: PayloadAction<PointInfoSet<PointInfo['isAddressCourierDelivery']>>
    ) => {
      state[getPointType(key)].isAddressCourierDelivery = value
    },
    setOrderAddIsAddressTerminalDelivery: (
      state,
      { payload: { key, value } }: PayloadAction<PointInfoSet<PointInfo['isAddressTerminalDelivery']>>
    ) => {
      state[getPointType(key)].isAddressTerminalDelivery = value
    },
    setOrderAddIsCourier: (state, { payload: { key, value } }: PayloadAction<PointInfoSet<PointInfo['isCourier']>>) => {
      state[getPointType(key)].isCourier = value
    },
    // TODO добавить add
    setOrderTerminals: (state, { payload: { key, value } }: PayloadAction<PointInfoSet<PointInfo['terminals']>>) => {
      state[getPointType(key)].terminals = value
    },
    // TODO добавить add
    setOrderSelectedTerminal: (
      state,
      { payload: { key, value } }: PayloadAction<PointInfoSet<PointInfo['selectedTerminal']>>
    ) => {
      state[getPointType(key)].selectedTerminal = value
    },
    setOrderAddComment: (state, { payload: { key, value } }: PayloadAction<PointInfoSet<PointInfo['comment']>>) => {
      state[getPointType(key)].comment = value
    },
    setOrderAddIsDaDataDisable: (state, { payload }: PayloadAction<OrderAddStore['isDadataDisable']>) => {
      state.isDadataDisable = payload
    },
    setOrderAddErrorAddress: (
      state,
      { payload: { key, value } }: PayloadAction<PointInfoSet<PointInfo['errorAddress']>>
    ) => {
      state[getPointType(key)].errorAddress = value
    },
    setFullInfo: (state, { payload }: PayloadAction<OrderAddStore>) => payload,
    setCustomerId: (state, { payload }: PayloadAction<OrderAddStore['customerId']>) => {
      state.customerId = payload
    }
  }
})

export const orderAddReducer = orderAddSlice.reducer

export const orderAddActions = orderAddSlice.actions
